import styles from "./Gallery.module.css";
import tempImage from "../../../../../assets/tempIMG1.jpg";
import { useContext, useEffect } from "react";
import NavigationContext from "../../../../store/navigation-context";

const tempImages = [tempImage, tempImage, tempImage, tempImage, tempImage];

export default function Gallery({ images, featuredImage }) {
  const navCtx = useContext(NavigationContext);

  const onImageShow = (e) => {
    const key = e.currentTarget.getAttribute("value");
    navCtx.setShowImages({
      state: true,
      images: images ? images : [...tempImage],
      key: parseInt(key),
    });
  };

  return (
    <main className={styles.main}>
      <img
        src={featuredImage || tempImage}
        alt="Image."
        className={`${styles.image} ${styles[`main-image`]}`}
        value={0}
        onClick={onImageShow}
      />
      <div className={styles[`images-grid`]}>
        {images &&
          images.length > 1 &&
          images.map((image, key) => {
            if (key > 0 && key < 5) {
              return (
                <img
                  key={key}
                  onClick={onImageShow}
                  src={image || tempImage}
                  value={key}
                  alt="Image."
                  className={`${styles.image} ${styles[`secondary-image`]} ${
                    styles[`image${key}`]
                  }`}
                />
              );
            }
          })}
      </div>
    </main>
  );
}
